import styled from "@emotion/styled";
import { graphql, StaticQuery } from "gatsby";
import React from "react";
import { Container } from '../grid/grid.component';
import { responsiveFont, responsiveWidth, settings } from '../grid/settings';
import { external_link } from '../grid/typography.component';


class DealerList extends React.Component {

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            dealers: allPrismicDealer {
                nodes {
                  prismicId
                  lang
                  data {
                    name
                    address
                    phone
                    website
                  }
                }
            }
          }
        `
        }
        render={data => (
          <Dealers>
            <Container>
              <DealerRowHeader>
                <div>Name</div>
                <div>Address</div>
                <div>Tel</div>
                <div>Website</div>
              </DealerRowHeader>
              {data.dealers.nodes.map(dealer => (
                <DealerRow key={dealer.prismicId} {...dealer.data} />
              ))}
            </Container>
          </Dealers>
        )}
      />

    )
  }
}

export default DealerList




const DealerRow = ({ name, address, phone, website }) => (
  <DealerRowWrapper>
    <div className="dealer-name">{name}</div>
    <div className="dealer-data">{address}</div>
    <div className="dealer-data">{phone}</div>
    <div className="dealer-data"><a href={`${website}`} target="_blank" rel="noopener noreferrer" css={external_link}>WEBSITE</a></div>
  </DealerRowWrapper>
);

const DealerPadding = {
  min: 40,
  max: 50,
}

const Dealers = styled.div`
  
  
  line-height: ${settings.typo.dealer.height};

  .dealer-name, .dealer-data{
    font-size: ${settings.typo.dealer.max}px;
  }
  .dealer-data{
    font-size: ${settings.typo.dealer.min}px;
  }

  @media (min-width: ${settings.mobileWidth}px){
    .dealer-data{
      font-size: ${settings.typo.dealer.max}px;
    }
  }
`
const DealerRowHeader = styled.div`
  
  color: #6E6E6E;
  ${responsiveFont(settings.typo.dealerHeader)};
  ${responsiveWidth('padding-bottom', DealerPadding.min, DealerPadding.max)}
  text-transform: uppercase;
  display: flex;
  letter-spacing: .3em;
  @media (max-width: ${settings.mobileWidth - 1}px){
    display: none;
    
  }

  div{
    flex: 1 1 auto;
    max-width: 30%;
  }
  div:last-of-type{
    
    max-width: 120px;

  }
`


const border = '#DBD9CE';

const DealerRowWrapper = styled.div`
  
  ${responsiveWidth('padding-top', DealerPadding.min, DealerPadding.max)}
  ${responsiveWidth('padding-bottom', DealerPadding.min, DealerPadding.max)}

  border-top: 1px solid ${border};
  &:last-of-type{
    border-bottom: 1px solid ${border};
  }
  .dealer-name{
    margin-bottom: 15px;
  }

  @media (min-width: ${settings.mobileWidth}px){
    display: flex;
    
  }

  div{

    @media (min-width: ${settings.mobileWidth}px){
      flex: 1 1 auto;
      max-width: 30%;
    }
  }
  .dealer-data:last-of-type{
    
    max-width: 120px;

    @media (max-width: ${settings.mobileWidth - 1}px){
      max-width: auto;
      margin-top: 30px;
    }
    a{
      padding-top: 0;
    }
  }
`
